export const handleCloseFunction = (dispatch, resetShipperTruckSelected, handleIsOpen) => {
  dispatch(resetShipperTruckSelected());
  handleIsOpen();
};

export const handleOpenAddFunction = (dispatch, addShipperTruckMode, handleIsOpen) => {
  dispatch(addShipperTruckMode());
  handleIsOpen();
};

export const setMapDataFunction = (setMapData, shipperTrucks, handleIsOpen) => {
  setMapData(
    Object.keys(shipperTrucks)?.map(id => shipperTrucks[id]).map(shipperTruck => {
      return {
        ...shipperTruck,
        modal: handleIsOpen
      };
    }).flat()
  );
};
